/*
 * HomePage
 */

import React from 'react';
import { useSelector } from 'react-redux';

// Material Resources

// Components & Others

// Styles & Images
import useStyles from './styles';
import InvestorProfile from './profile';
import InvestorCards from './cards';
import getClientMode from 'src/store/utils-store/selectors';

function InvestorDashboardPage(props) {
  const classes = useStyles();
  const modeClient = useSelector(getClientMode());
  const contentStyle = modeClient ? classes.contentDark : classes.content;
  const profileStyle = modeClient ? classes.contentProfileDark : classes.contentProfile;

  return (
    <>
      <div className={contentStyle}>
        <InvestorCards  />
        {/* <OnboardingSteps/> */}
      </div>
      <div className={profileStyle}>
        <InvestorProfile />
      </div>
    </>
  );
}

export default InvestorDashboardPage;
